import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import { changeBgState } from "Store/appStore/action";
import { langCheck, getCustomTheme, getWatermarkSettings } from "Pub/js/utils.js";
import { getBackgroundObject, requestStyleSettings, getWaterMarkObject } from './common';
import SubjectSetting from '../Customize/SubjectSetting';
import subjectDefaultData from "Pub/js/subjectDefaultData";
import Logo from "Pub/js/subjectIcons";
import PermissionArea from './components/PermissionArea';
import LogoArea from './components/LogoArea';
import platform from 'Pub/js/platform';
const { getLangCode } = platform;
import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";
import ImgChooser from '../../components/ImgChooser';
const {
    defaultBackgroundObject,
    defaultLight,
} = subjectDefaultData;

const GlobalStyleSetting = props => {
    const title = langCheck("0000PUB-000392"); /**多语设置：企业风格设置-全局 */
    const defaultObj = {
        backgroundObject: defaultBackgroundObject,
        data: {
            // color: "#F1F1F1",
            color: defaultLight,
            icon: "",
            customColors: []
        },
        groupChecked: true,
        userChecked: true,
    };
    let loginLogoUrl = 'hotwebs/nccloud/resources/uap/public/img/lang/simpchn/logo.png';
    let loginCenterImgUrl = 'hotwebs/nccloud/resources/uap/public/img/lang/simpchn/login-center.png';
    const local = getLangCode('langCode');
    if (local === 'tradchn') {
        loginLogoUrl = 'hotwebs/nccloud/resources/uap/public/img/lang/tradchn/logo.png';
        loginCenterImgUrl = 'hotwebs/nccloud/resources/uap/public/img/lang/tradchn/login-center.png';
    } else if (local === 'english') {
        loginLogoUrl = 'hotwebs/nccloud/resources/uap/public/img/lang/english/logo.png';
        loginCenterImgUrl = 'hotwebs/nccloud/resources/uap/public/img/lang/english/login-center.png';
    }
    const logoBox = [
        // {
        //     fieldid: 'replaceNavDefaultLogo', // 自动化测试标记
        //     picture: Logo.defaultLogo,
        //     name: langCheck('0000PUB-000420'), // 多语 - 导航栏-默认主题logo  
        //     smallName: langCheck('0000PUB-000421'), //多语 - 推荐高度22px，默认格式为png,
        //     content: <p style={{ wordWrap: 'break-word' }}>{langCheck('0000PUB-000431')}<span id="replaceImgUrl">hotwebs/nccloud/resources/workbench/public/common/main/images/Group.png</span></p>, // 多语-在服务器上，环境所在目录中找到该图片进行替换，图片名称要与环境中保持一致，目录地址如下：
        // },
        // {
        //     fieldid: 'replaceNavOrderLogo',
        //     picture: Logo.orderLogo,
        //     name: langCheck('0000PUB-000422'), // 多语 - 导航栏-其他主题logo  
        //     smallName: langCheck('0000PUB-000421'), //多语 - 推荐高度22px，默认格式为png,
        //     content: <p style={{ wordWrap: 'break-word' }}>{langCheck('0000PUB-000431')}<span id="replaceImgUrl">hotwebs/nccloud/resources/workbench/public/common/main/images/GroupWhite.png</span></p>,
        // },
        {
            fieldid: 'uploadNavLogo',
            picture: Logo.defaultLogo,
            name: langCheck('0000PUB-000674'), // 多语 - 导航栏logo
            smallName: langCheck('0000PUB-000421'), // 多语 - 推荐高度22px，默认格式为png,
            customOprBtn: <div>
                <ImgChooser
                    needCrop={false}
                    onChange={value => {
                        const newCompanyStyleSettingObj = _.cloneDeep(companyStyleSettingObj);
                        newCompanyStyleSettingObj.data.nvigapic = value;
                        setCompanyStyleSettingObj(newCompanyStyleSettingObj);
                    }}
                >
                    <p className='logo-area-item-right'>{langCheck('0000PUB-000449')}</p>
                </ImgChooser>
            </div>
        },
        {
            fieldid: 'replaceLoginLogo',
            picture: Logo.loginLogo,
            name: langCheck('0000PUB-000423'), // 多语 -登录页logo  
            smallName: langCheck('0000PUB-000421'), //多语 - 推荐高度22px，默认格式为png,
            content: <p style={{ wordWrap: 'break-word' }}>{langCheck('0000PUB-000431')}<span id="replaceImgUrl">{loginLogoUrl}</span></p>,
        },
        {
            fieldid: 'replaceBrowserLogo',
            picture: Logo.browserlogo,
            name: langCheck('0000PUB-000660'), // 多语 -浏览器窗口logo
            smallName: langCheck('0000PUB-000661'), // 多语 -默认格式为ico格式,
            content: <p style={{ wordWrap: 'break-word' }}>{langCheck('0000PUB-000431')}<span id="replaceImgUrl">webapps/nc_web/favicon.ico</span></p>,
        },
        {
            fieldid: 'replaceLoginBackground',
            picture: Logo.loginPageBg,
            name: langCheck('0000PUB-000424'), // 多语 - 登录页背景图片  
            smallName: langCheck('0000PUB-000425'), //多语 - 默认为png格式,
            content: <p style={{ wordWrap: 'break-word' }}>
                {langCheck('0000PUB-000431')}
                <span id="replaceImgUrl">
                    hotwebs/nccloud/resources/uap/public/img/background_video.png
                    <br />
                    hotwebs/nccloud/resources/uap/public/img/backgroun_video_uap.mp4
                </span>
            </p>,
        },
        {
            fieldid: 'replaceLoginBackground1',
            picture: Logo.loginPageBg1,
            name: langCheck('0000PUB-000486'), // 多语 - 登录页宣传语  
            smallName: langCheck('0000PUB-000425'), //多语 - 默认为png格式,
            content: <p style={{ wordWrap: 'break-word' }}>{langCheck('0000PUB-000431')}<span id="replaceImgUrl">{loginCenterImgUrl}</span></p>,
        },
    ];
    const [companyStyleSettingObj, setCompanyStyleSettingObj] = useState(defaultObj);
    const subjectRef = useRef(null);

    useEffect(() => {
        // 获取企业风格设置请求接口
        Ajax({
            url: "/nccloud/workbench/corporatestyle/querycorporatestyle.do",
            data: { styletype: '0' },
            noNeedShowError: true,
            success: async ({ data: { data, success } }) => {
                if (success && Object.keys(data).length) {
                    data.customColors = await getCustomTheme({ styletype: '0' });
                    let watermarkObject = await getWatermarkSettings({ styletype: '0', pk_group: '' });
                    watermarkObject = getWaterMarkObject(watermarkObject);

                    if (data.isDefault || data.customtheme_del) {
                        if (data.customtheme_del) {
                            Notice({
                                status: "warning",
                                msg: langCheck("0000PUB-000487"), /*当前主题色已删除，恢复默认主题*/
                            });
                        }
                        const { groupmodify = true, usermodify = true } = data;
                        // 走默认样式
                        const obj = JSON.parse(JSON.stringify(defaultObj));
                        obj.data = { ...obj.data, ...data };
                        setStyleSettings({
                            ...obj,
                            groupChecked: groupmodify,
                            userChecked: usermodify,
                            watermarkSetting: watermarkObject.watermarkSetting,
                        })
                    } else {
                        let { groupmodify, usermodify } = data;
                        const backgroundObject = getBackgroundObject(data);
                        const obj = {
                            groupChecked: groupmodify,
                            userChecked: usermodify,
                            data: data,
                            backgroundObject,
                            watermarkSetting: watermarkObject.watermarkSetting,
                        };
                        setStyleSettings(obj);
                    }
                }
            },
            error: () => {
                // 走默认样式
                setStyleSettings({ ...defaultObj });
            },
        });
    }, []);

    const setStyleSettings = (settings) => {
        setCompanyStyleSettingObj(settings);
        subjectRef.current.setStyleSettings(settings.data, settings.watermarkSetting);
    }

    // 企业风格设置接口
    const companyStyleSettingFn = ({ usermodify, styleSettings }) => {
        const { changeBgState } = props;
        let { groupChecked, userChecked, data } = companyStyleSettingObj;
        const { ts, nvigapic, pk_group, customColors } = data;
        let obj = {
            styletype: '0', //企业风格类型 0-全局  1-集团
            groupmodify: groupChecked, //是否允许集团修改
            usermodify: userChecked, //是否允许用户修改
            ts, //解决并发问题
            nvigapic, // logo
            ...styleSettings
        };
        requestStyleSettings({ obj, usermodify, changeBgState, pk_group }).then(([styleData, watermarkData]) => {
            const newCompanyStyleSettingObj = JSON.parse(JSON.stringify(companyStyleSettingObj));
            newCompanyStyleSettingObj.data = { ...styleData, customColors }; // 拼接上自定义主题色数据
            let watermarkObject = getWaterMarkObject(watermarkData);
            newCompanyStyleSettingObj.watermarkSetting = watermarkObject.watermarkSetting;
            setStyleSettings(newCompanyStyleSettingObj);
        });
    };
    return (
        <SubjectSetting
            title={title}
            logoArea={<LogoArea isGlobal={true} logoBox={logoBox} />}
            permissionArea={<PermissionArea isGlobal={true} setCompanyStyleSettingObj={setCompanyStyleSettingObj} companyStyleSettingObj={companyStyleSettingObj} />}
            companyStyleSettingObj={companyStyleSettingObj}
            styleType='0'
            companyStyleSettingFn={companyStyleSettingFn}
            setCompanyStyleSettingObj={setCompanyStyleSettingObj}
            styleSettingName='global'
            subjectRef={ref => subjectRef.current = ref}
            hideBackBtn={props.hideBackBtn}
        />
    );
};

export default connect(
    () => { },
    { changeBgState },
)(GlobalStyleSetting);
